import React from 'react';
import { Button } from '../../../components/ui/button';
import iconEmoji from '../../../assets/icon1.webp';
import iconSpark from '../../../assets/icon2.webp';

export const Hero: React.FC = () => {
  return (
    <section className="relative overflow-hidden hero-gradient text-white">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -left-16 w-72 h-72 bg-white/20 blur-[150px]" />
        <div className="absolute -bottom-20 -right-24 w-80 h-80 bg-[#ffe619]/25 blur-[200px]" />
        <img
          src={iconEmoji}
          alt="Emoji festivo"
          className="hero-icon-primary absolute left-12 top-14 sm:w-8 w-16 opacity-20 sm:opacity-100 transition-opacity drop-shadow-[0_20px_45px_rgba(0,0,0,0.35)]"
          style={{ width: '250px' }}
        />
        <img
          src={iconSpark}
          alt="Destello vibrante"
          className="hero-icon-spark absolute right-6 lg:right-16 top-32 w-10 sm:w-12 opacity-20 sm:opacity-100 transition-opacity drop-shadow-[0_15px_35px_rgba(255,255,255,0.55)]"
        />
      </div>

      <div className="container relative mx-auto px-6 pt-28 pb-40 md:pb-44 lg:pt-32 lg:pb-48 text-center">
        <div className="max-w-2xl mx-auto space-y-8">
          <p className="text-xs font-semibold uppercase tracking-[0.55em] text-[#ffe619]">
            Ene 12 · MACA · Punta del Este
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-white leading-tight">
            Punta Tech Meetup <br />
            <span className="text-primary">Calendario Oficial</span>
          </h1>
          
          <p className="text-base md:text-lg lg:text-xl text-white/80 max-w-lg mx-auto">
            Descubrí charlas, experiencias y encuentros del ecosistema Punta Tech Meetup.
          </p>

          
        </div>
      </div>
    </section>
  );
};